<template>
  <requested-trip-datatable></requested-trip-datatable>
  <requested v-if="false" />
</template>

<script>
import Requested from "./requested/Index.vue";
import RequestedTripDatatable from "./requested_trip_datatable/Index.vue";

export default {
  name: "TripRequested",
  components: { Requested, RequestedTripDatatable },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
